import React, {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {
    userSearchResultNewslettersDataSelector,
    userSearchResultNewslettersResultSelector,
} from '../../slices/user-search-result-newsletters.slice';

type Props = {
    userId: number,
    allNewsletters: Record<string, string>,
};

export const NewslettersCell = ({userId, allNewsletters}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultNewslettersDataSelector);
    const result = useSelector(userSearchResultNewslettersResultSelector);

    const newsletters = useMemo(
        () => result?.data[userId],
        [result, userId],
    );

    const getNewsletterByCode = useCallback((newsletterType: string) => {
        return Object.entries(allNewsletters)
            .map(([code, description]) => ({code, description}))
            .find(newsletter => newsletter.code === newsletterType)
            ?.description;
    }, [allNewsletters]);

    if (isLoading || loadingError || !newsletters) {
        return null;
    }


    return (
        <span>
            {newsletters.length
                ? newsletters.map(getNewsletterByCode).join('; ')
                : 'No Newsletter'}
        </span>
    );
};
